import {
  DemostackLabelIllustration,
  MarkOrangeIllustration,
} from '@carboncopyco/illustrations';
import { Button, TextBase, TextCaption } from '@carboncopyco/ui';
import { LINK_RELEASE_NOTES } from '../../../shared/constants/constants';
import { openLinkInBrowser } from '../../../util/path-util';

const AppVersionModal = ({
  appVersion,
  updateAvailable,
  onSubmit,
  showInfo,
  onCloseModal,
  postponeUpdate = true,
}: {
  appVersion: string;
  updateAvailable?: boolean;
  onSubmit?: () => void;
  showInfo: boolean;
  onCloseModal?: () => void;
  postponeUpdate?: boolean;
}) => {
  const ModalContent = () => {
    if (showInfo)
      return (
        <div className="flex flex-col mt-8 mb-1 align-center px-4">
          <a
            className="text-ds-link-400 text-ds-primary text-ds-400 mb-2 mt-2"
            href="https://www.demostack.com/"
            onClick={(e) => openLinkInBrowser(e, 'https://www.demostack.com/')}
          >
            Demostack.com
          </a>
          <TextCaption
            label="Copyright @ 2023 Demostack, All rights reserved"
            color="text-ds-black"
          />
        </div>
      );
    if (updateAvailable)
      return (
        <div className="flex flex-col px-16">
          <Button
            label="Update & Relaunch"
            onClick={() => {
              onSubmit?.();
              onCloseModal?.();
            }}
            className="min-w-[87px] px-4 bg-ds-primary py-2 rounded-md mt-6 text-ds-natural-50"
          />{' '}
          {postponeUpdate && (
            <Button
              label="Later"
              onClick={onCloseModal}
              className="min-w-[87px] py-2 rounded-md mt-2 text-ds-primary border border-ds-primary"
            />
          )}
        </div>
      );
    return (
      <div className="flex flex-col mt-8 align-center px-16">
        <div className="mt-7">
          <p className="text-[16px] text-ds-natural-600">{`Current version: V${appVersion}`}</p>
        </div>
        <div
          onClick={() => {
            window.dsDesktop.shellOpenExternal(LINK_RELEASE_NOTES);
          }}
          className="cursor-pointer"
        >
          <TextCaption
            label="View release notes"
            color="text-ds-natural-600"
            underline
          />
        </div>
        <div className="mt-12">
          <TextBase
            label="You have the latest version"
            color="text-ds-black"
          />
        </div>
      </div>
    );
  };

  const ModalHeader = () => {
    const versionLabel = updateAvailable
      ? `New update available: ${appVersion}`
      : `Current version: V${appVersion}`;
    return (
      <>
        <MarkOrangeIllustration />
        <div className="pt-3">
          <DemostackLabelIllustration />
        </div>
        {(updateAvailable || showInfo) && (
          <>
            <div className="mt-7">
              <p className="text-[16px] text-ds-natural-600">{versionLabel}</p>
            </div>
            <div
              onClick={() => {
                window.dsDesktop.shellOpenExternal(LINK_RELEASE_NOTES);
              }}
              className="cursor-pointer"
            >
              <TextCaption
                label="View release notes"
                color="text-ds-natural-600"
                underline
              />
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <div className="flex flex-col align-center justify-center py-3">
      <ModalHeader />
      <ModalContent />
    </div>
  );
};

export default AppVersionModal;
